import { useEffect } from 'react';

import useValueRef from './useValueRef';

/**
 * @param {keyof WindowEventMap|(keyof WindowEventMap)[]|undefined} type
 * @param {EventListener=} callback
 * @param {string=} selector
 * @param {boolean=} preventDefault
 */
const useOn = (type, callback, selector, preventDefault) => {
  const callbackRef = useValueRef(callback);

  useEffect(() => {
    if (!type || !type.length) {
      return;
    }

    const handler = event => {
      if (preventDefault) {
        event.preventDefault();
      }

      callbackRef.current?.(event);
    };

    const eventNames = Array.isArray(type) ? type : [type];
    const nodes = selector ? document.querySelectorAll(selector) : [document];

    for (const eventName of eventNames) {
      for (const node of nodes) {
        node.addEventListener(eventName, handler);
      }
    }

    return () => {
      for (const eventName of eventNames) {
        for (const node of nodes) {
          node.removeEventListener(eventName, handler);
        }
      }
    };
  }, [type, selector, preventDefault]);
};

export default useOn;
